import Promise from 'bluebird';

export const getTaskPoller = ({
  task, // func returns a promise which resolves to a value { isFinished }
  interval = 30000, // in milli-seconds
}) => {
  let timerId;
  let stopRunning = false;
  let counter = 0;
  let taskPromise = null;

  const start = () => {
    if (taskPromise) {
      return taskPromise;
    }

    taskPromise = new Promise((resolve, reject) => {
      // run task immediately once
      counter = 1;
      task().then((result) => {
        const { isFinished } = result || {};
        if (!isFinished && !stopRunning) {
          timerId = setInterval(() => {
            if (!stopRunning) {
              counter += 1;
              task().then(({ isFinished: isDone }) => {
                if (isDone) {
                  clearInterval(timerId);
                  timerId = undefined;
                  resolve(counter);
                }
              }).catch((err) => {
                clearInterval(timerId);
                timerId = undefined;
                reject(err);
              });
            } else {
              if (timerId) {
                clearInterval(timerId);
                timerId = undefined;
              }
              resolve(counter);
            }
          }, interval);
        } else {
          resolve(counter);
        }
      }).catch((err) => {
        reject(err);
      });
    });

    return taskPromise;
  };

  const stop = () => {
    stopRunning = true;
    return taskPromise;
  };

  return { start, stop };
};
